jQuery(document).ready(function($){

    var classController = new ScrollMagic.Controller();

    // var home_hero = new ScrollMagic.Scene({
    //     triggerElement: '.home-hero',
    //     duration: 0,
    //     triggerHook: 0.5,
    //     offset: 200,
    //     // reverse: false
    // })
    // .setClassToggle('.home-hero', 'home-hero-animating')
    // .addTo(classController);


    var home_intro_section = new ScrollMagic.Scene({
        triggerElement: '.home-intro-section',
        duration: 0,
        triggerHook: 0.8,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.home-intro-section', 'home-intro-section-animating')
    // .addIndicators()
    .addTo(classController);


    var what_we_do = new ScrollMagic.Scene({
        triggerElement: '.what-we-do',
        duration: 0,
        triggerHook: 0.8,
        // offset: 200,
        reverse: false
    })
    .setClassToggle('.what-we-do', 'what-we-do-animating')
    // .addIndicators()
    .addTo(classController);


    var gray_row = new ScrollMagic.Scene({
        triggerElement: '.gray-row',
        duration: 0,
        triggerHook: 0.8,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.gray-row', 'gray-row-animating')
    // .addIndicators()
    .addTo(classController);


    var home_about_numbers = new ScrollMagic.Scene({
        triggerElement: '.stat-section',
        duration: 0,
        triggerHook: .8,
        offset: 0,
        reverse: false
    })
    .setClassToggle('.stat-section', 'stat-section-animating')
    // .addIndicators()
    .on('start', function () {
        console.log("here");
        jQuery('.count-one').each(function () {
            jQuery(this).prop('Counter',0).animate({
                Counter: jQuery(this).text()
            }, {
                duration: 1000,
                easing: 'swing',
                step: function (now) {
                    jQuery(this).text(Math.ceil(now));
                }
            });
        });
        jQuery('.count-two').each(function () {
            jQuery(this).prop('Counter',0).animate({
                Counter: jQuery(this).text()
            }, {
                duration: 1000,
                easing: 'swing',
                step: function (now) {
                    jQuery(this).text(Math.ceil(now));
                }
            });
        });
        jQuery('.count-three').each(function () {
            jQuery(this).prop('Counter',0).animate({
                Counter: jQuery(this).text()
            }, {
                duration: 1000,
                easing: 'swing',
                step: function (now) {
                    jQuery(this).text(Math.ceil(now));
                }
            });
        });
    })
    .addTo(classController);

    var home_about = new ScrollMagic.Scene({
        triggerElement: '.home-about .about-text-section',
        duration: 0,
        triggerHook: 0.8,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.about-text-section', 'about-text-section-animating')
    // .addIndicators()
    .addTo(classController);


    var footer = new ScrollMagic.Scene({
        triggerElement: 'footer',
        duration: 0,
        triggerHook: 0.9,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.footer', 'footer-animating')
    // .addIndicators()
    .addTo(classController);

    var footer_navigation = new ScrollMagic.Scene({
        triggerElement: '.footer-navigation',
        duration: 0,
        triggerHook: 1,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.footer-navigation', 'footer-navigation-animating')
    // .addIndicators()
    .addTo(classController);



});
